<template>
    <div>
        <div class="row">
            <div class="col">
                <div class="sau-bx bx-pad">
                    <div class="row">
                        <div class="col text-center">
                            <h4>Control Panel Access</h4>
                            <p>Login to the Servers Australia Managed Wordpress Control Panel.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <sau-loading v-if="!ready">
                                <template slot="message">Fetching Access Details</template>
                            </sau-loading>

                            <div class="row" v-if="ready && retrieved">
                                <div class="col">
                                    <div class="row pt-2">
                                        <div class="col-lg-6 drop">
                                            <div class="sau-bx p-6 h-100">
                                                <h5>Username</h5>
                                                <p v-if="accessUsername">{{ accessUsername }}</p>
                                                <p v-else>Not Set</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="sau-bx p-6 h-100">
                                                <h5>Password</h5>
                                                <div v-show="!showAccessPassword">
                                                    <!-- Match the dots to the password length -->
                                                    <template v-if="accessPassword">
                                                        <span
                                                            class="sau-pwd-dot space"
                                                            v-for="(key, index) in accessPassword.length"
                                                            :key="index"
                                                        ></span>
                                                        <a
                                                            href="#"
                                                            class="sau-linx green sau-font sm pl-2"
                                                            @click.prevent="showAccessPassword = !showAccessPassword"
                                                        >Show</a>
                                                    </template>
                                                    <template v-else>
                                                        <p>Not Set</p>
                                                    </template>
                                                </div>
                                                <div v-show="showAccessPassword">
                                                    <span
                                                        class="clear-password wm-hide"
                                                    >{{ accessPassword }}</span>
                                                    <a
                                                        href="#"
                                                        class="sau-linx green sau-font sm pl-2"
                                                        @click.prevent="showAccessPassword = !showAccessPassword"
                                                    >Hide</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-else-if="ready && !retrieved">
                                <div class="col">
                                    <sau-apiro-response type="error" support="true">
                                        <template
                                            slot="message"
                                        >There was an issue retrieving your login details.</template>
                                        <template slot="details">
                                            <p>For more information please contact our Support Team.</p>
                                        </template>
                                    </sau-apiro-response>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row pt-4">
                        <div class="col mx-auto text-center">
                            <!-- only display console link if logins were also retrieved -->
                            <div
                                v-if="ready && form && !errorInForm && retrieved"
                                v-html="form"
                                class="control-panel-form"
                            ></div>
                            <!-- show error only if the previous error isn't set (so only one displays at a time) -->
                            <div v-else-if="ready && retrieved">
                                <sau-apiro-response type="error" support="true">
                                    <template
                                        slot="message"
                                    >There was an issue retrieving your console link.</template>
                                    <template slot="details">
                                        <p v-if="errorInForm">{{ form }}</p>
                                        <p
                                            v-else
                                        >For more information please contact our Support Team.</p>
                                    </template>
                                </sau-apiro-response>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showAccessPassword: false,
            retrieved: false,
            accessPassword: '',
            accessUsername: '',
            form: '',
            ready: false
        };
    },
    created() {
        this.startApp();
    },
    methods: {
        startApp() {
            let loginPromise = this.getLoginDetails().then(response => {
                if (response.data) {
                    this.accessUsername = response.data.username;
                    this.accessPassword = response.data.password;
                    this.retrieved = true;
                }
            });

            let accessPromise = this.getAccessDetails().then(response => {
                if (response.data.status == 'success') {
                    this.form = response.data.records.output;
                }
            });

            Promise.all([loginPromise, accessPromise]).then(
                () => (this.ready = true)
            );
        }
    },
    computed: {
        errorInForm() {
            return this.form.toLowerCase().includes('error') ? true : false;
        }
    }
};
</script>
<style>
.space {
    margin: 0px 2px;
}
.control-panel-form input[type='submit'] {
    cursor: pointer !important;
    background: #00ce7d !important;
    color: #fff !important;
    padding: 8px 15px 8px 15px !important;
    border: 1px solid #00ce7d !important;
}
</style>

